export var MemberLoanStatus;
(function (MemberLoanStatus) {
    MemberLoanStatus[MemberLoanStatus["WaitingConfirmation"] = 0] = "WaitingConfirmation";
    MemberLoanStatus[MemberLoanStatus["WaitingFee"] = 1] = "WaitingFee";
    MemberLoanStatus[MemberLoanStatus["RejectedByMember"] = 2] = "RejectedByMember";
    MemberLoanStatus[MemberLoanStatus["RejectedByClub"] = 3] = "RejectedByClub";
    MemberLoanStatus[MemberLoanStatus["Accepted"] = 4] = "Accepted";
    MemberLoanStatus[MemberLoanStatus["Ended"] = 5] = "Ended";
    MemberLoanStatus[MemberLoanStatus["Cancelled"] = 6] = "Cancelled";
})(MemberLoanStatus || (MemberLoanStatus = {}));
export var getMemberLoanStatusValues = function () {
    return [
        MemberLoanStatus.WaitingConfirmation,
        MemberLoanStatus.WaitingFee,
        MemberLoanStatus.RejectedByMember,
        MemberLoanStatus.RejectedByClub,
        MemberLoanStatus.Accepted,
        MemberLoanStatus.Ended,
        MemberLoanStatus.Cancelled,
    ];
};
export var getMemberLoanStatusText = function (state, loan) {
    if (loan === void 0) { loan = null; }
    if (state === MemberLoanStatus.WaitingConfirmation) {
        return "Čeká na potvrzení";
    }
    if (state === MemberLoanStatus.WaitingFee) {
        return "Čeká na úhradu poplatku";
    }
    if (state === MemberLoanStatus.RejectedByMember) {
        return "Zamítnuto členem";
    }
    if (state === MemberLoanStatus.RejectedByClub) {
        return "Zamítnuto klubem";
    }
    if (state === MemberLoanStatus.Accepted) {
        if (loan === null) {
            return "Schváleno";
        }
        else {
            var dateNow = new Date();
            if (dateNow < loan.fromDate) {
                return "Schváleno";
            }
            if (dateNow > loan.toDate) {
                return "Po platnosti";
            }
            return "Aktivní";
        }
    }
    if (state === MemberLoanStatus.Ended) {
        return "Ukončeno";
    }
    if (state === MemberLoanStatus.Cancelled) {
        return "Zrušeno";
    }
    return "";
};
